<template>
  <div id="app">
    <transition name="long-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'app',
  components: { },
  computed: {
    ...mapState(['globalErrorMessage', 'scriptsLoaded', 'notAuthorized']),
    ...mapState('primary', ['organization']),
    ...mapGetters('auth', ['isLoggedIn']),
  },
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    ...mapMutations(['SET_SCRIPTS_LOADED']),
    ...mapMutations('auth', ['SET_USER']),
  },
  watch: {
    globalErrorMessage() {
      if (this.globalErrorMessage) {
        this.$toasted.show(this.globalErrorMessage, {
          position: 'bottom-center',
          containerClass: 'my-toasted-container',
          singleton: true,
          action: [
            {
              text: 'Close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
          duration: 15 * 1000,
        });
        this.$store.commit('SET_GLOBAL_ERROR_MESSAGE', { message: null });
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import '@/scss/loader.scss';
@import '@/scss/transitions.scss';
@import '@/scss/toasted.scss';
@import '@/scss/tooltip.scss';
@import '@/scss/tiles.scss';
@import '@/scss/dashboard.scss';
@import '@/scss/vue-multiselect.scss';
@import '@/scss/charts.scss';
@import '@/scss/removablecards.scss';
@import '@/scss/contentnav.scss';
@import '@/scss/scrollbar.scss';

$radius-small: 0px;
$radius: 0px;
$radius-large: 0px;
// Sticking with Avenir for now, but could switch to this if machines OS's don't have it
$family-sans-serif: "Avenir", "Nunito", Helvetica, Arial, sans-serif;
$size-6: .95rem;
$size-5: 1rem;
$size-4: 1.25rem;
$size-3: 1.5rem;
$size-2: 2rem;
$size-1: 2.5rem;

//Form overrides
$control-radius: 0px;
$label-weight: 400;
$label-color: $font-color;
$input-background-color: lightslategray;
$input-border-color: $border-color;
$input-color: $font-color;
$button-color: $main-background;
$button-background-color: $link-color;
$button-hover-color: $form-subitem;

$tag-background-color: $tag-background; // lightslategray;
$tag-radius: 3px;

$primary: $tag-hover;


// Import Bulma and Buefy styles
// @import "~bulma/sass/utilities/_all";
@import "~bulma";
@import "~buefy/src/scss/buefy";

@import '@/scss/forms.scss';
@import '@/scss/tables.scss';
@import '@/scss/svg.scss';
@import '@/scss/tabs.scss';
@import '@/scss/utils.scss';
@import '@/scss/tags.scss';
@import '@/scss/dropdown.scss';

html, body, #app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  min-width: $page-min-width;
  // font-size: .95rem;
  background: $main-background;
}

body::-webkit-scrollbar {
  display: none;
}

.multiselect__input {
  height: 2.25em;
}
</style>
